import { SEO_TITLE_SELLERS_ON_SERVER } from 'mk/autogenerated/translations/SellerSearchPage.8c1f53209dda03bbaf0e490c31ecff60'
import SellerSearch from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch';
import { sellerSearchLoad } from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.actions';
import sellerSearchReducer from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.reducers';
import sellerSearchSaga from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.sagas';
import { getSellerSearchState } from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.selectors';
import { SellerEntity, SellerSchema } from 'mk2/apps/bazaar/schemas';
import { AppName } from 'mk2/containers/Application/Application';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page from 'mk2/pages/Page';
import { getRequestUser, AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { HeaderMenuItem, MenuSelection, UserEntity } from 'mk2/schemas';
import { getDenormalizedEntities } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {}

interface StateProps {
    sellers: SellerEntity[];
    total: number;
    loadingState: LoadingState;
    errorMessage: string;
    requestUser: UserEntity;
}

interface DispatchProps {
    onLoad(start: number);
}

type RouteProps = RouteComponentProps<{}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class SellerSearchPage extends Page<OwnProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const subState = getSellerSearchState(state);

            return {
                total: subState.total,
                loadingState: subState.loadingState,
                errorMessage: subState.errorMessage,
                sellers: getDenormalizedEntities<SellerEntity>(state, SellerSchema, subState.ids),
                requestUser: getRequestUser(state),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: sellerSearchLoad,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_SELLERS_ON_SERVER;
    }

    public render(props: Props): false | JSX.Element {
        return <SellerSearch {...props} />;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: app,
            activeItem: HeaderMenuItem.BazaarSellerSearch,
        };
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.bazaar.sellerSearch', sellerSearchReducer);
        store.injectSaga('containers.bazaar.sellerSearch', sellerSearchSaga);
    }
}
